import { generateQueryParamsString, Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/autocomplete';

export default {
  getAutocompleteResults(subject, filterQuery) {
    const tenantId = store.getters.tenant.id;
    const queryString = generateQueryParamsString(filterQuery);
    const request = new Request(`${baseURL}/${tenantId}/${subject}${queryString}`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
};
